import React from 'react';
import ReactDOM from 'react-dom';
// import { hydrate, render } from "react-dom";
import App from './App';
import './index.css';
import "react-toastify/dist/ReactToastify.css";
import "font-awesome/css/font-awesome.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-phone-number-input/style.css'
import 'react-photo-view/dist/react-photo-view.css';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import store from './Redux/store';

ReactDOM.render(
  <BrowserRouter>
    <HelmetProvider>
        <Provider store={store}>
          <App />
        </Provider>
    </HelmetProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
